<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{ storeName }}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="ttleft">
        <span>我的展示</span>
      </div>
      <div class="ttright" v-show="isfabu" @click="toFabu">
        <span>发布</span>
      </div>
    </div>
    <div class="addbox">
      <div style="display: flex;align-items: center;cursor: pointer;" @click="isadd = true">
        <img src="../../assets/img/icon/jia2.png" style="height:17px;" alt="">
        <span style="color:#0b8586;">新增</span>
      </div>
      <span>新增图片上限为十张</span>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th>排序</th>
            <th>图片</th>
            <th>题目</th>
            <th>简介</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in storeList" :key="index">
            <td>{{ item.sort }}</td>
            <td>
              <img :src="item.resUrl" class="tbImage" alt="">
            </td>
            <td>{{ item.title }}</td>
            <td>
              <span class="tbxiangqing" @click="todetail(item.abstract)">详情</span>
            </td>
            <td>
              <img style="margin-right:10px;cursor: pointer;" src="../../assets/img/icon/bianji.png"
                @click="toUpdataResources(item.id)" alt="" />
              <img src="../../assets/img/icon/shanchu.png" style="cursor: pointer;" @click="toDeleteResources(item.id)"
                alt="" />
            </td>
          </tr>
          <tr v-show="storeList.length < 1">
            <td colspan="5">暂无图文信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-dialog :visible.sync="isadd" :before-close="toClose" class="add" width="950px">
      <webupload fileaccept=".jpg,.jpeg,.png" :Maxfileszie="3" :uploadtype="2" :orgid="orgid" :onSuccess="handleSuccess"
        :before-upload="beforeAvatarUpload">
        <div class="addImg">
          <span v-show="!imgUrl" style="font-weight: 100;font-size: 40px;">+</span>
          <span v-show="!imgUrl">图片上传</span>
          <img v-show="imgUrl" :src="imgUrl" alt="">
        </div>
      </webupload>
      <span class="addtop2">支持jpg,jpeg,png格式，图片小于2M；图片比例670*378</span>
      <div class="addtop3">
        <span>题目：</span>
        <el-input placeholder="请输入题目" v-model="title" style="width:494px" clearable>
        </el-input>
      </div>
      <div class="addtop4">
        <span>简介：</span>
        <!-- <el-input type="textarea"
                  class="addjianjie"
                  placeholder="请输入简介"
                  v-model="jianjie">
        </el-input> -->
        <!-- <div class="addjianjie"
             ref="imageEditer"></div> -->
        <imageEditer class="addjianjie" :changeText="changeText" ref="imageEditer" :jianjie="jianjie"></imageEditer>
      </div>
      <span class="addtop2" style="margin-left:50px">建议行高1.6、字号16、字体微软雅黑、两端对齐、首行空2个字</span>
      <div class="addtop3" style="margin-top:15px">
        <span>排序：</span>
        <el-input placeholder="请输入数字1-10，前端按此序号排序" v-model="paixu" style="width:494px" clearable>
        </el-input>
      </div>
      <div class="addtop5">
        <div @click="ToSub">
          <span>保存</span>
        </div>
        <div style="background: #BDC1C1;" @click="isadd = false">
          <span>取消</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isdetail" class="add" width="950px">
      <div v-html="abstract"></div>
    </el-dialog>
  </div>
</template>

<script>

import webupload from '../../components/webupload/webupload.vue';
import imageEditer from '../../components/imageEditer';
export default {
  name: 'usInfor',
  components: {
    webupload,
    imageEditer
  },
  data() {
    return {
      storeName: '',
      storeList: [],
      orgid: 0,
      isadd: false,
      title: '',
      jianjie: '',
      paixu: '',
      imgUrl: '',
      imgId: 0,
      id: 0,
      abstract: '',
      isdetail: false,
      uid: 0,
      isfabu: false,
      editor: null
    };
  },
  created() {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'))
    this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id)
    this.GetMyStoreList()
    this.getShow()
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess(response) {
      this.imgId = response.resid;
      this.imgUrl = response.ossfileurl;
    },
    GetMyStoreList() {
      this.httphelper
        .post('api/EnterpriseApi/GetOrganVisitList', {
          type: 1,
          orgId: this.orgid,
          page: 1,
          limit: 10
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data;
          }
        });
    },
    ToSub() {
      this.httphelper
        .post('/api/EnterpriseApi/SaveOrganVisit', {
          id: this.id,
          title: this.title,
          abstract: this.jianjie,
          resId: this.imgId,
          resUrl: this.imgUrl,
          type: 1,
          coverPictureUrl: '',
          coverPictureId: 0,
          sort: Number(this.paixu),
          orgId: this.orgid,
          isShow: true,
          createUserID: this.uid
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '新增成功',
              type: 'success'
            });
            this.toClose()
          }
        });
    },
    toDeleteResources(id) {
      this.httphelper
        .post('api/EnterpriseApi/DelOrganVisit', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        });
    },
    toUpdataResources(id) {
      this.httphelper
        .post('/api/EnterpriseApi/GetOrganVisitInfoByID', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.id = res.data.data.id
            this.title = res.data.data.title
            this.jianjie = res.data.data.abstract
            this.imgId = res.data.data.resId
            this.imgUrl = res.data.data.resUrl
            this.paixu = res.data.data.sort
            this.isadd = true
            var test1 = setTimeout(() => {
              this.$refs.imageEditer.toText()
              clearTimeout(test1);
            }, 300);

          }
        });
    },
    todetail(text) {
      this.abstract = text
      this.isdetail = true
    },
    toFabu() {
      this.httphelper
        .post('api/EnterpriseApi/SaveOrganVisitConfig', {
          orgId: this.orgid,
          type: 1,
          createUserID: this.uid
        })
        .then(res => {
          if (res.data.code == 200) this.$message.success('发布图文展示成功');
        });
    },
    toClose() {
      this.title = ''
      this.jianjie = ''
      this.$refs.imageEditer.clear()
      this.imgId = 0
      this.imgUrl = ''
      this.paixu = ''
      this.id = 0
      this.isadd = false
    },
    getShow() {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganVisitList', {
          orgId: Number(localStorage.getItem('storeId'))
        })
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.length == 0) {
              this.isfabu = true
              return
            }
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].type != 1) {
                this.isfabu = true
              }
            }
          }
        });
    },
    changeText(e) {
      this.jianjie = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.toptitle {
  width: 100%;
  height: 57px;
  background: #f6f7fb;
  padding-left: 17px;
  padding-right: 20px;
  margin: 30px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.ttleft {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #0b8586;
  line-height: 56px;
}

.ttright {
  width: 100px;
  height: 30px;
  background: #0b8586;
  border: 1px solid #0b8586;
  border-radius: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.listbox {
  width: 100%;
}

.listbox table {
  width: 100%;
  border-collapse: collapse;
}

.listbox th {
  height: 44px;
  background-color: #0b8586;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  border-color: #e2e2e2;
  border: 1px solid #e2e2e2;
}

.listbox td {
  height: 58px;
  background-color: #0b8586;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  background: #fafafa;
  text-align: center;
  border: 1px solid #e2e2e2;
}

.addbox {
  margin: 20px 0;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.addbox span {
  margin-left: 10px;
}

.tbImage {
  width: 65px;
  height: 45px;
}

.add ::v-deep .el-dialog__body {
  padding: 27px 57px 65px 57px;
}

.addImg {
  width: 160px;
  height: 104px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #a8a8a8;
  align-items: center;
  justify-content: space-around;
}

.addImg img {
  width: 160px;
  height: 104px;
  border-radius: 5px;
  cursor: pointer;
}

.addtop2 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0b8586;
  line-height: 56px;
  margin-bottom: 6px;
}

.addtop3 {
  display: flex;
  align-items: center;
}

.addtop4 {
  display: flex;
  align-items: flex-start;
  margin-top: 15px;
}

.addjianjie {
  width: 790px;
  height: 172px;
}

.addjianjie ::v-deep .w-e-text-container {
  height: 130px !important;
}

.addjianjie ::v-deep .w-e-text {
  min-height: 130px !important;
}

.addtop5 {
  margin-top: 63px;
  display: flex;
  justify-content: center;
}

.addtop5 div {
  width: 165px;
  height: 40px;
  background: #0b8586;
  border-radius: 20px;
  line-height: 40px;
  text-align: center;
  margin: 0 5px;
  color: #ffffff;
  cursor: pointer;
}

.tbxiangqing {
  color: #0b8586;
  cursor: pointer;
}
</style>